import SignInForm from "../organisms/forms/signIn/SignInForm";
import SignUpForm from "../organisms/forms/signUp/SignUpForm";
import { useTranslation } from "react-i18next";
import Content from "../templates/wrapper/Content";
import TabsRoot from "../molecules/tabs/TabsRoot";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDialog } from "../../hooks/useDialog";
import { messageKeyMap } from "../../helpers/const";

export default function SignInPage() {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const { showDialog } = useDialog();
  useEffect(() => {
    if (location.state?.type === "confirmUser" && location.state?.message) {
      showDialog(
        t("confirmUser.title"),
        t(location.state?.message),
        t("dialog.okey"),
        false,
        "",
        "success"
      );
      return;
    }

    const firstTrueKey = Object.keys(messageKeyMap).find(
      (key) => location.state?.[key]
    );

    if (firstTrueKey) {
      const message = t(messageKeyMap[firstTrueKey]);
      showDialog(
        "",
        message,
        t("dialog.okey"),
        true,
        "",
        "success",
        null,
        true
      );
    }
  }, [location.state, i18n.language, t]);

  useEffect(() => {
    const navigateMessage = localStorage.getItem("navigateMessage");
    
    if (!navigateMessage) return;
    const dialogMessage = Object.keys(messageKeyMap).find(
      (key) => navigateMessage === key
    );
    
    if (dialogMessage) {
      const message = t(messageKeyMap[dialogMessage]);
      localStorage.removeItem("navigateMessage");
      showDialog(
        "",
        message,
        t("dialog.okey"),
        true,
        "",
        "success",
        null,
        true
      );
    }
  }, [localStorage]);

  const tabsData = [
    { value: "signIn", label: t("signUp.login"), content: <SignInForm /> },
    {
      value: "signUp",
      label: t("signUp.createAccount"),
      content: <SignUpForm />,
    },
  ];
  return (
    <>
      <Content>
        <TabsRoot tabs={tabsData} defaultValue="signIn" />
      </Content>
    </>
  );
}
